export default __webpack_public_path__ + "static/cv-940dc3ac2106e8a5c10ceca5d3cd198f.pdf";